import { render, staticRenderFns } from "./DmqNewsletterUnsubscribe.vue?vue&type=template&id=470085b2&"
import script from "./DmqNewsletterUnsubscribe.vue?vue&type=script&lang=ts&"
export * from "./DmqNewsletterUnsubscribe.vue?vue&type=script&lang=ts&"
import style0 from "./DmqNewsletterUnsubscribe.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports